import { PersonaSdk, BearerTokenAuthenticationProvider } from '@applica-software-guru/persona-sdk'
import { config } from '@/lib/config'

export const sdk = new PersonaSdk(config.coreApiUrl, config.workflowsUrl, config.billingUrl)

export function createAuth(token: string) {
  return new BearerTokenAuthenticationProvider(token)
}
